import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { TableContext } from "../../index";
import * as urlService from "../../view/urlService";


export const useConfigChangeTableHelper = () => {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);

    const hardReload = (props = {}) => {
        setConfig({
            ...config,
            selected: [],
            selectAll: false,
            hardReload: true,
            lastUpdated: Date.now(),
            ...props
        });
    }

    const onDeviceClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('device')
        })
    }


    const onIPClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('ip')
        })
    }

    const onUserClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('user')
        })
    }

    const onDateClick = () => {
        history.push({
            pathname: history.pathname,
            search: urlService.updateSort('changeDate')
        })
    }

    const changeDeviceFilter = (value) => {

        if (Number(value) === -1) {
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('device')
            })
            return;
        }

        history.push({
            pathname: history.pathname,
            search: urlService.updateFilters('device', value)
        })
    }

    const updatePagination = (page, size) => {
        history.push(
            {
                pathname: history.pathname,
                search: urlService.updatePagination(page, size)
            }
        )
    }

    return {
        hardReload,
        onDeviceClick,
        onIPClick,
        onUserClick,
        onDateClick,
        updatePagination,
        changeDeviceFilter
    }
}
